import { ACTION_BUTTON_TYPE, CODE_BLOCK_TYPE, DIVIDER_TYPE, EMOJI_TYPE, FILE_UPLOAD_TYPE, GALLERY_TYPE, GIPHY_TYPE, HTML_TYPE, IMAGE_TYPE, MAP_TYPE, POLL_TYPE, VERTICAL_EMBED_TYPE, VIDEO_TYPE, COLLAPSIBLE_LIST_TYPE, LINK_BUTTON_TYPE, AUDIO_TYPE, TABLE_TYPE, LINK_PREVIEW_TYPE, INSERT_PLUGIN_BUTTONS, } from '@wix/ricos';
import { isDefined } from '../../../../ts-utils';
const PluginTypeToButtonMap = {
    [VERTICAL_EMBED_TYPE]: [
        INSERT_PLUGIN_BUTTONS.STORES,
        INSERT_PLUGIN_BUTTONS.EVENTS,
        INSERT_PLUGIN_BUTTONS.BOOKINGS,
    ],
    [IMAGE_TYPE]: INSERT_PLUGIN_BUTTONS.IMAGE,
    [GALLERY_TYPE]: INSERT_PLUGIN_BUTTONS.GALLERY,
    [POLL_TYPE]: INSERT_PLUGIN_BUTTONS.POLLS,
    [DIVIDER_TYPE]: INSERT_PLUGIN_BUTTONS.DIVIDER,
    [HTML_TYPE]: INSERT_PLUGIN_BUTTONS.HTML,
    [VIDEO_TYPE]: [
        INSERT_PLUGIN_BUTTONS.VIDEO,
        INSERT_PLUGIN_BUTTONS.SOUND_CLOUD,
        INSERT_PLUGIN_BUTTONS.YOUTUBE,
    ],
    [CODE_BLOCK_TYPE]: INSERT_PLUGIN_BUTTONS.CODE_BLOCK,
    [GIPHY_TYPE]: INSERT_PLUGIN_BUTTONS.GIF,
    [MAP_TYPE]: INSERT_PLUGIN_BUTTONS.MAP,
    [FILE_UPLOAD_TYPE]: INSERT_PLUGIN_BUTTONS.FILE,
    [EMOJI_TYPE]: INSERT_PLUGIN_BUTTONS.EMOJI,
    [ACTION_BUTTON_TYPE]: INSERT_PLUGIN_BUTTONS.BUTTON,
    [LINK_BUTTON_TYPE]: INSERT_PLUGIN_BUTTONS.BUTTON,
    [COLLAPSIBLE_LIST_TYPE]: INSERT_PLUGIN_BUTTONS.COLLAPSIBLE_LIST,
    [AUDIO_TYPE]: [
        INSERT_PLUGIN_BUTTONS.AUDIO,
        INSERT_PLUGIN_BUTTONS.SPOTIFY,
        INSERT_PLUGIN_BUTTONS.SOUND_CLOUD,
    ],
    [TABLE_TYPE]: INSERT_PLUGIN_BUTTONS.TABLE,
    [LINK_PREVIEW_TYPE]: [
        INSERT_PLUGIN_BUTTONS.INSTAGRAM,
        INSERT_PLUGIN_BUTTONS.TWITTER,
        INSERT_PLUGIN_BUTTONS.TIKTOK,
    ],
};
export const getExtToolbarPluginButtons = (plugins) => Object.keys(plugins)
    .flatMap((pluginType) => PluginTypeToButtonMap[pluginType])
    .filter(isDefined);
//# sourceMappingURL=buttons.js.map